import {
  DIMiddlewares,
  DIMixins,
  DITypes,
  DIValidators
} from "@/core/@types/types";
import F360AbstractSidebar from "@/core/common/F360AbstractSidebar";
import { IF360SidebarConfig } from "@/core/common/F360Sidebar";
import F360SidebarConfig from "@/core/common/F360SidebarConfig";
import F360ContabilSidebarConfig from "@/features/contabil/common/sidebar/F360ContabilSidebarConfig";
import F360FinancasSidebarConfig from "@/core/common/financas/sidebar/F360FinancasSidebarConfig";
import SlackMessageAdapter from "@/core/common/slackMessage/services/adapters/SlackMessageAdapter";
import { ISlackMessage } from "@/core/common/slackMessage/services/ports/SlackMessage";
import PesquisaNpsHandler from "@/features/shared/PesquisaNPS/PesquisaNpsHandler";
import { IPesquisaNpsHandler } from "@/features/shared/PesquisaNPS/protocols/IPesquisaNpsHandler";
import AmountFormat from "@/core/composables/AmountFormat/AmountFormat";
import Shortcut from "@/core/composables/Shortcuts/Shortcut";
import VueNotificationAdapter from "@/core/composables/notification/VueNotificationAdapter";
import { IToastNotification } from "@/core/composables/notification/types";
import { IEvent } from "@/core/plugins/Events/Event";
import WindowEvent from "@/core/plugins/Events/WindowEvent";
import { F360CurrencyJs } from "@/core/plugins/currency.js/Currencyjs";
import { IF360Currency } from "@/core/plugins/currency.js/types";
import { IF360Date } from "@/core/plugins/date/F360Date";
import { IF360DateUtils } from "@/core/plugins/date/F360DateUtils";
import { F360DayJs } from "@/core/plugins/dayjs/DayJs";
import DayJsUtils from "@/core/plugins/dayjs/DayJsUtils";
import { F360Lodash } from "@/core/plugins/lodash/Lodash";
import { IF360Utility } from "@/core/plugins/lodash/types";
import LocalStorageAdapter from "@/core/plugins/storage/LocalStorageAdapter";
import { IStorage } from "@/core/plugins/storage/Storage";
import { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import UserProfileStorageMixinAdapter from "@/core/plugins/storage/UserProfileStorageMixinAdapter";
import { IGithubGateway } from "@/core/services/Github/gateways/GithubGateway";
import GithubHttpGateway from "@/core/services/Github/gateways/GithubHttpGateway";
import ContabilHttpClient from "@/features/contabil/services/ContabilAxiosAdapter";
import { ContabilDITypes } from "@/features/contabil/services/types";
import { IDevGateway } from "@/core/services/dev/gateways/DevGateway";
import DevHttpGateway from "@/core/services/dev/gateways/DevHttpGateway";
import FinancasHttpClient from "@/core/services/financas/FinancasHttpClient";
import { IFinancasGateway } from "@/core/services/financas/gateways/FinancasGateway";
import FinancasHttpGateway from "@/core/services/financas/gateways/FinancasHttpGateway";
import { UserProfile } from "@/core/services/financas/gateways/UserProfile";
import { UserRoles } from "@/core/services/financas/gateways/UserRoles";
import IndicadoresHttpClient from "@/features/financas/views/Indicadores/services/IndicadoresHttpClient";
import GameficacaoDashboardGateway from "@/core/services/shared/GameficacaoDashboard/GameficacaoDashboardGateway";
import { IGameficacaoDashboardGateway } from "@/core/services/shared/GameficacaoDashboard/IGameficacaoDashboardGateway";
import GithubAxiosAdapter from "@/core/services/GithubAxiosAdapter";
import HttpMiddlewareIntercept from "@/core/services/HttpMiddlewareIntercept";
import AxiosHttpTokenInterceptor from "@/core/services/middleware/AxiosTokenInterceptor";
import { IGetDataFromHeaders } from "@/core/services/middleware/GetDataFromHeaders";
import HttpFileNameFromHeader from "@/core/services/middleware/HttpFileNameFromHeader";
import { IHttpTokenInterceptor } from "@/core/services/middleware/HttpTokenInterceptor";
import { IPesquisaNpsGateway } from "@/core/services/shared/pesquisaNPS/IPesquisaNpsGateway";
import PesquisaFakeNpsGateway from "@/core/services/shared/pesquisaNPS/PesquisaNpsFakeGateway";
import pesquisaNpsGateway from "@/core/services/shared/pesquisaNPS/PesquisaNpsRequest";
import { IPesquisaGateWay } from "@/core/services/shared/pesquisaReacao/PesquisaGateWay";
import GetPesquisaGateWay from "@/core/services/shared/pesquisaReacao/PesquisaHttpGateway";
import {
  HttpClient,
  IHttpMiddlewareIntercept
} from "@/core/services/protocols/types";
import { IUseLocalFiltersStoreMixins } from "@/features/financas/views/Indicadores/store/dashboard/UseLocalFilterStoreMixins";
import UseLocalFilterStoreMixinsAdapter from "@/features/financas/views/Indicadores/store/dashboard/UseLocalFilterStoreMixinsAdapter";
import { IUsePreferenceStoreMixins } from "@/core/store/userPreferences/IUsePreferenceStoreMixins";
import UsePreferenceStoreMixinsAdapter from "@/core/store/userPreferences/UsePreferenceStoreMixinsAdapter";
import AcessoContabilValidator from "@/core/validators/AcessoContabilValidator";
import CadisValidator from "@/core/validators/CadisValidator";
import CieloValidator from "@/core/validators/CieloValidator";
import ContabilLiberadoValidator from "@/core/validators/ContabilLiberadoValidator";
import F360CLIValidator from "@/core/validators/F360CLIValidator";
import F360ComercialValidator from "@/core/validators/F360ComercialValidator";
import { IF360FeatureFlagValidator } from "@/core/validators/F360FeatureFlagValidator";
import { IF360Validator } from "@/core/validators/F360Validator";
import FeatureFlagValidator from "@/core/validators/FeatureFlagValidator";
import SysAdminValidator from "@/core/validators/sysAdmin/SysAdminValidator";
import AdminGestaoContratosValidator from "@/core/validators/adminGestaoContratos/AdminGestaoContratosValidator";
import FeatureFlagAdminValidator from "@/core/validators/featureFlagAdmin/FeatureFlagAdminValidator";
import TesteGeraisValidator from "@/core/validators/TesteGeraisValidator";
import MostrarControleDebitoUseCase from "@/features/contabil/dashboard/widgets/controleDebitos/adapters/MostrarControleDebitoUseCase";
import MostrarControleDebitosGatewayAdapter from "@/features/contabil/dashboard/widgets/controleDebitos/adapters/MostrarControleDebitosGatewayAdapter";
import { IMostrarControleDebitoUseCase } from "@/features/contabil/dashboard/widgets/controleDebitos/ports/MostrarControleDebito";
import { ControleDebitosDI } from "@/features/contabil/dashboard/widgets/controleDebitos/types";
import { Container } from "inversify";
import { preferenciasContainer } from "@/features/financas/views/Indicadores/widgets/Preferencias/container/preferenciasContainer";
import { convertersContainer } from "@/core/di/convertersContainer";
import { downloadContainer } from "@/core/di/downloadContainer";
import { helpersContainer } from "@/core/di/helpersContainer";
import { pluggyContainer } from "@/core/di/pluggyConnector";
import { IInteressesGateway } from "@/core/services/financas/interesses/InteressesGateway";
import InteressesHttpGateway from "@/core/services/financas/interesses/InteressesHttpGateway";
import CancelationMiddleware from "@/core/services/CancelationMiddleware";
import ClosersValidator from "@/core/validators/ClosersValidator";
import { IF360ClosersValidator } from "@/core/validators/F360ClosersValidator";
import { voucherContainer } from "@/ui/vue-components/components/VoucherContabil/container";
import { IndicadoresDITypes } from "@/features/financas/views/Indicadores/container/types";
import { userContainer } from "@/core/di/user";
import ShowEducaValidator from "@/core/validators/ShowEducaValidator";
import {
  f360CalendlyDI,
  IF360Calendly
} from "@/core/plugins/calendly/F360Calendly";
import { F360CalendlyAdapter } from "@/core/plugins/calendly/F360CalendlyAdapter";
import { agendamentosContainer } from "@/features/contabil/agendamentos/container";
import { primeiroAcessoContabilContainer } from "@/features/contabil/primeiroAcesso/container";
import { ITakeScreenshot } from "@/core/composables/TakeScreenshot/types";
import useTakeScreenshot from "@/core/composables/TakeScreenshot/useTakeScreenshot";
import UsuarioAdminValidator from "@/core/validators/usuarioAdmin/UsuarioAdminValidator";
import { IUsuarioAdminValidator } from "@/core/validators/usuarioAdmin/IUsuarioAdminValidator";
import { AntecipaSlackContainer } from "@/features/antecipa/common/slackMessage/container/AntecipaSlackContainer";
import { IAntecipaPermissionValidator } from "@/core/validators/acessoAntecipa/IAntecipaPermissionValidator";
import AntecipaPermissionValidator from "@/core/validators/acessoAntecipa/AntecipaPermissionValidator";
import { financasFeaturesContainer } from "@/features/financas/container/financasFeaturesContainer";
import { FeedDeNovidadesSignal } from "@/features/shared/Feed/services/FeedDeNovidadesSignal/FeedDeNovidadesSignal";
import FeedDeNovidadesSignalAdapter from "@/features/shared/Feed/services/FeedDeNovidadesSignal/FeedDeNovidadesSignalAdapter";
import { IWebSocketClient } from "@/core/services/websocket/IWebSocketClient";
import WebSocketClient from "@/core/services/websocket/WebSocketClient";
import FinancasDevHttp, {
  FinancasDevHttpDi,
  IFinancasDevHttp
} from "@/core/services/FinancasDevHttp";
import HorizonsGatewayAdapter from "@/core/services/horizons/adapters/HorizonsGatewayAdapter";
import { IHorizonsGateway } from "@/core/services/horizons/ports/HorizonsGateway";
import HorizonsHttpClient from "@/core/services/HorizonsHttpClient";
import { userPreferencesContainer } from "@/core/container/preferencias/UserPreferencesContainer";
import { atualizarCertificadoContainer } from "@/features/financas/widgets/atualizarCertificado/container/atualizarCertificadoContainer";
import FinancasApiHttpClient from "@/core/services/FinancasApiHttpClient";
import { typeformCsatContainer } from "@/features/financas/widgets/TypeformCSAT/container/typeformCsatContainer";

const diContainer = new Container();

diContainer.bind<IEvent>(DITypes.EVENT).to(WindowEvent).inSingletonScope();

diContainer.bind<IStorage>(DITypes.STORAGE).to(LocalStorageAdapter);

diContainer
  .bind<IToastNotification<unknown>>(DITypes.NOTIFICATION)
  .to(VueNotificationAdapter);

diContainer
  .bind<IUserProfileStorageMixin>(DIMixins.USER_PROFILE_STORAGE)
  .to(UserProfileStorageMixinAdapter);

diContainer
  .bind<IUseLocalFiltersStoreMixins>(DIMixins.LOCAL_FILTERS_STORE)
  .to(UseLocalFilterStoreMixinsAdapter);

diContainer
  .bind<IUsePreferenceStoreMixins>(DIMixins.PREFERENCES_STORE)
  .to(UsePreferenceStoreMixinsAdapter);

diContainer.load(preferenciasContainer);

diContainer
  .bind<IHttpTokenInterceptor<unknown>>(DITypes.INTERCEPTOR)
  .to(AxiosHttpTokenInterceptor);

diContainer
  .bind<HttpClient>(DITypes.CONTABIL_HTTP_CLIENT)
  .to(ContabilHttpClient);

diContainer
  .bind<HttpClient>(DITypes.INDICADORES_HTTP_CLIENT)
  .to(IndicadoresHttpClient);

diContainer
  .bind<HttpClient>(DITypes.HORIZONS_HTTP_CLIENT)
  .to(HorizonsHttpClient);

diContainer
  .bind<HttpClient>(DITypes.FINANCAS_HTTP_CLIENT)
  .to(FinancasHttpClient);

diContainer
  .bind<HttpClient>(DITypes.FINANCAS_API_HTTP_CLIENT)
  .to(FinancasApiHttpClient);
// .when(() => {
//   return import.meta.env.PROD;
// });

diContainer.bind<IFinancasDevHttp>(FinancasDevHttpDi).to(FinancasDevHttp);

diContainer.bind(CancelationMiddleware).toSelf();

diContainer
  .bind<IF360SidebarConfig>(F360AbstractSidebar)
  .toSelf()
  .inSingletonScope();

diContainer.bind(F360ContabilSidebarConfig).toSelf().inSingletonScope();

diContainer.bind(F360FinancasSidebarConfig).toSelf().inSingletonScope();

diContainer
  .bind<IWebSocketClient>(DITypes.WEBSOCKET_CLIENT)
  .to(WebSocketClient);

diContainer.bind<HttpClient>(DITypes.GITHUB_HTTP_CLIENT).toDynamicValue(() => {
  const event = diContainer.get<IEvent>(DITypes.EVENT);

  const client = new GithubAxiosAdapter(event);

  return client;
});

diContainer.bind<IGithubGateway>(DITypes.GITHUB_GATEWAY).to(GithubHttpGateway);

diContainer
  .bind<IHorizonsGateway>(DITypes.HORIZONS_GATEWAY)
  .to(HorizonsGatewayAdapter);

diContainer
  .bind<IFinancasGateway>(DITypes.FINANCAS_AUTH)
  .to(FinancasHttpGateway);

diContainer
  .bind<IPesquisaGateWay>(DITypes.PESQUISA_GATEWAY)
  .to(GetPesquisaGateWay);

diContainer
  .bind<IPesquisaNpsGateway>(DITypes.PESQUISA_NPS_GATEWAY)
  .to(pesquisaNpsGateway);

diContainer
  .bind<IPesquisaNpsHandler>(DITypes.PESQUISA_NPS_HANDLER)
  .to(PesquisaNpsHandler);

diContainer
  .bind<IInteressesGateway>(IndicadoresDITypes.INTERESSES_GATEWAY)
  .to(InteressesHttpGateway);

diContainer.bind(PesquisaFakeNpsGateway).toSelf();

diContainer.bind<IDevGateway>(DITypes.DEV).to(DevHttpGateway);

diContainer.bind<IF360Date>(DITypes.DATE).to(F360DayJs);

diContainer.bind<IF360DateUtils>(DITypes.DATE_UTILS).to(DayJsUtils);

diContainer.bind<IF360Currency>(DITypes.CURRENCY).to(F360CurrencyJs);

diContainer.bind<AmountFormat>(AmountFormat).to(AmountFormat);

diContainer.bind<IF360Utility>(DITypes.UTILITY).to(F360Lodash);

diContainer
  .bind<IHttpMiddlewareIntercept>(DITypes.HTTP_MIDDLEWARE_INTERCERPT)
  .to(HttpMiddlewareIntercept);

diContainer.bind<UserProfile>(UserProfile).to(UserProfile).inRequestScope();
diContainer.bind<UserRoles>(UserRoles).to(UserRoles).inRequestScope();
diContainer.bind<Shortcut<unknown>>(Shortcut).to(Shortcut).inRequestScope();

diContainer.bind<IF360Validator>(DIValidators.CIELO).to(CieloValidator);
diContainer.bind<IF360Validator>(DIValidators.CADIS).to(CadisValidator);
diContainer
  .bind<IF360Validator>(DIValidators.SHOW_EDUCA)
  .to(ShowEducaValidator);
diContainer.bind(DIValidators.SYS_ADMIN).to(SysAdminValidator);
diContainer
  .bind<IF360Validator>(DIValidators.ADMIN_GESTAO_CONTRATOS)
  .to(AdminGestaoContratosValidator);
diContainer
  .bind<IF360Validator>(DIValidators.FEATURE_FLAG_ADMIN)
  .to(FeatureFlagAdminValidator);

diContainer
  .bind<IAntecipaPermissionValidator>(DIValidators.ACESSO_ANTECIPA)
  .to(AntecipaPermissionValidator);

diContainer
  .bind<IGetDataFromHeaders>(DIMiddlewares.FILE_NAME_HEADER)
  .to(HttpFileNameFromHeader);

diContainer.load(helpersContainer);
diContainer.load(userContainer);
diContainer.load(downloadContainer);
diContainer.load(pluggyContainer);
diContainer.load(convertersContainer);
diContainer.load(voucherContainer);
diContainer.load(userPreferencesContainer);
diContainer.loadAsync(AntecipaSlackContainer);
diContainer.loadAsync(financasFeaturesContainer);

diContainer
  .bind<IF360Validator>(DIValidators.ACESSO_CONTABIL)
  .to(AcessoContabilValidator);

diContainer
  .bind<IF360Validator>(DIValidators.CONTABIL_LIBERADO)
  .to(ContabilLiberadoValidator);

diContainer.bind(F360SidebarConfig).toSelf();

diContainer.bind(DIValidators.TESTES_GERAIS).to(TesteGeraisValidator);

diContainer.bind(DIValidators.COMERCIAL).to(F360ComercialValidator);

diContainer.bind(DIValidators.CLI_VALIDATOR).to(F360CLIValidator);

diContainer
  .bind(ContabilDITypes.MOSTRAR_CONTROLE_DEBITOS_GATEWAY)
  .to(MostrarControleDebitosGatewayAdapter);
diContainer
  .bind<IMostrarControleDebitoUseCase>(
    ControleDebitosDI.MOSTRAR_CONTROLE_DEBITOS_USE_CASE
  )
  .to(MostrarControleDebitoUseCase);

diContainer
  .bind<IF360FeatureFlagValidator>(DIValidators.FEATURE_FLAGS)
  .to(FeatureFlagValidator);

diContainer
  .bind<IUsuarioAdminValidator>(DIValidators.USUARIO_ADMIN)
  .to(UsuarioAdminValidator);

diContainer
  .bind<IF360ClosersValidator>(DIValidators.CLOSER)
  .to(ClosersValidator);

diContainer
  .bind<IGameficacaoDashboardGateway>(DITypes.GAMEFICACAO_DASHBOARD)
  .to(GameficacaoDashboardGateway);

diContainer.bind<ISlackMessage>(DITypes.SLACK_MENSAGEM).to(SlackMessageAdapter);

// SignalR Feed de Novidades
diContainer
  .bind<FeedDeNovidadesSignal>(DITypes.FEED_DE_NOVIDADES)
  .to(FeedDeNovidadesSignalAdapter)
  .inSingletonScope();

diContainer
  .bind<ITakeScreenshot>(DITypes.HANDLE_TAKESCREENSHOT)
  .to(useTakeScreenshot);

diContainer.bind<IF360Calendly>(f360CalendlyDI).to(F360CalendlyAdapter);

diContainer.load(primeiroAcessoContabilContainer);

diContainer.load(agendamentosContainer);

diContainer.load(atualizarCertificadoContainer);

diContainer.load(typeformCsatContainer);

export { diContainer };
